import type { ReactElement } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

interface LoadingTableProps {
  baseContainerClasses: string;
  className?: string;
}

export const LoadingTable = ({
  className,
  baseContainerClasses,
}: LoadingTableProps): ReactElement => (
  <div className={classNames(baseContainerClasses, "gap-4", className)}>
    <div className="bg-tertiary h-6 w-1/2 animate-pulse rounded-full" />
    <div className="space-y-3">
      <div className="flex gap-4">
        {Array.from({ length: 4 }, (_, index) => (
          <div
            key={`table-header-${index}`}
            className="bg-tertiary h-5 flex-1 animate-pulse rounded-full"
          />
        ))}
      </div>
      {Array.from({ length: 5 }, (_, rowIndex) => (
        <div key={`table-row-${rowIndex}`} className="flex gap-4">
          {Array.from({ length: 4 }, (_, colIndex) => (
            <div
              key={`table-cell-${rowIndex}-${colIndex}`}
              className={classNames(
                "bg-tertiary h-4 animate-pulse rounded-full",
                colIndex === 0 ? "w-16" : "flex-1",
              )}
            />
          ))}
        </div>
      ))}
    </div>
  </div>
);
